import React from 'react';
import RegisterSection from '../Components/Register';

const registerPage = () => (
  <RegisterSection />
);

export default registerPage;
